<script>
export default {
    data() {
        return {
            current: 0,
        }
    },
    props: {
        items: Array
    },
    methods: {
        activateItem(key) {
            this.current = key;
        }
    },
}
</script>

<style>
    .tab-button .border-box::after {
        @apply left-1;
        content: ' ';
        position: absolute;
        z-index: 1;
        height: 4px;
        width: 0;
        bottom: -2px;
        background: rgb(6, 28, 49);
        border-radius: 4px;
        opacity: 0;
        transition-property: width, height, opacity;
        transition-duration: 0.3s;
    }

    .tab-button:hover .border-box::after,
    .tab-button.tab-button-active .border-box::after {
        @apply w-14;
        opacity: 1;
    }

    .tab-button.tab-button-active .border-box::after {
        @apply bg-primary;
    }

    @screen sm {
        .tab-button .border-box::after {
            @apply bottom-3;
            height: 0;
            width: 4px;
            right: -2px;
            left: inherit;
        }

        .tab-button:hover .border-box::after,
        .tab-button.tab-button-active .border-box::after {
            @apply h-14;
            width: 4px;
        }
    }
</style>

<template>
    <div class='flex flex-col sm:flex-row items-start sm:items-center bg-sky-50 rounded-xl sm:min-h-[460px] '>
        <ol class='w-full grid grid-flow-col gap-2 justify-center sm:grow-0 shrink-0 sm:w-auto sm:grid-cols-1 sm:grid-flow-row sm:justify-start'>
            <li v-for="(item, key) in items">
                <button @click='activateItem(key)' :disabled="key === this.current" class='tab-button w-16 h-16 sm:w-20 sm:h-20 rounded-xl flex relative justify-center items-center' :class="{'tab-button-active': key === this.current}">
                    <span class='border-box block border-slate-400 border-b sm:border-b-0 sm:border-r h-full w-14 sm:w-full sm:h-14 flex justify-center items-center'>
                        <img :src="item.TabIcon.URL" class='h-10 w-auto' :alt="item.TabIcon.Title">
                    </span>
                </button>
            </li>
        </ol>
        <div class='grow shrink min-h-[300px] p-12 lg:p-16 xl:p-24'>
            <div v-for="(item, key) in items" class='mb-3'>
                <div v-if="key === this.current" class='flex flex-wrap gap-8 md:gap-12 sm:flex-nowrap items-center relative'>
                    <div class='grow shrink'>
                        <h4>{{item.Title}}</h4>
                        <div v-html="item.Content"></div>
                    </div>
                    <div class='grow sm:grow-0 w-full sm:w-24 sm:grow-0 sm:shrink-0' v-if="item.Image.ID">
                        <img :src="item.Image.URL" class='block w-1/2 max-h-[250px] mx-auto sm:max-h-none sm:h-4/5 sm:w-auto' :alt="item.Image.Title">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
